<style>
.el-table .el-table_1_column_6  {
  text-align: left;
}
</style>
<template>
  <div class="tuolele-main-box sort-management-detail">
    <div class="tuolele-main-search tuolele-main-search-item">
      <el-form :inline="true" :model="frianceListQuery" class="fn-clear">
        <el-form-item label="" class="fn-left">
          <el-input v-model="frianceListQuery.mobile" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <el-input v-model="frianceListQuery.id" placeholder="单号" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <Select key="10" :selected.sync="frianceListQuery.payment_method" :data="paySelectsData" clearable placeholder="请选择支付方式" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <Select key="11" :selected.sync="frianceListQuery.status" :data="statusSelectsData" clearable placeholder="请选择审核状态" />
        </el-form-item>
        <el-form-item class="fn-left">
          <el-date-picker v-model="frianceListQuery.time" style="margin-left: 5px;" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
        </el-form-item>
        <el-form-item label="金额范围" class="fn-left fn-clear">
          <el-input v-model="frianceListQuery.amount_down" style="width: 120px;" type="number" class="fn-left" placeholder="金额下限" />
          <span class="fn-left">--</span>
          <el-input v-model="frianceListQuery.amount_up" class="fn-left" type="number" style="width:120px;" placeholder="金额上限" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <el-button type="primary" @click="searchQuestion('reset')">查询</el-button>

        </el-form-item>
        <el-form-item label="" class="fn-left">
          <el-button type="success" @click="fnDownloadData()">下载数据</el-button>

        </el-form-item>
      </el-form>
    </div>
    <span style="color: red;">注：提现名称标红，表示该提现名称跟员工重名（不区分是否离职）</span>
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
      >

        <el-table-column prop="create_time" label="申请时间" />
        <el-table-column width="100px" prop="id" label="单号" />
        <el-table-column width="90px" prop="type_name" label="来源" />
        <el-table-column width="110px" prop="mobile" label="手机号" />
        <el-table-column width="200px" prop="sub_names" label="学员">
          <template slot-scope="scope">
            <div v-html="scope.row.sub_names" />
          </template>
        </el-table-column>
        <el-table-column prop="payment_method" width="300px" label="提现方式">
          <template slot-scope="scope">
            <p>提现方式：{{ scope.row.payment_method }}</p>
            <p :style="{ color: scope.row.duplicate_count > 0 ? 'red' : 'inherit' }">
              提现名称：{{ scope.row.payment_account }}
            </p>
            <p>提现账号：{{ scope.row.payment_card }}</p>
            <p v-if="scope.row.payment_method=='银行卡'">开户银行：{{ scope.row.bank_name }}</p>
            <p v-if="scope.row.payment_method=='银行卡'">开户支行：{{ scope.row.bank_branch_name }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="提现金额">
          <template slot-scope="scope">
            <span>{{ scope.row.amount/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status_text" label="审核状态" />
        <el-table-column prop="remark" label="备注" />
        <el-table-column prop="status_name" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="startAuditing(scope.row)">审核</el-button>
            <el-button size="mini" type="success" @click="fnUpdateRemark(scope.row.id,scope.row.remark)">备注</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="frianceListQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="frianceListQuery.total"
            :page-size="frianceListQuery.limit"
            @current-change="searchQuestion()"
          >
            <div class="chax">
              {{ frianceListQuery.p }}/{{
                frianceListQuery.total > 0 ? Math.ceil(frianceListQuery.total / frianceListQuery.limit) : 1
              }}
            </div>
          </el-pagination>
          <div class="insert">
            <el-button type="primary">确定</el-button>
            <span class="pagination-count">
              符合查询结果:
              <i>{{ frianceListQuery.total }}条</i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      class="custom-yue-dialog"
      width="400px"
    >
      <div>
        <span v-if="checkResult.check_pass == false" style="color:red;margin-bottom: 5px;">{{ checkResult.check_message }}，请谨慎</span>
        <span v-else style="margin-bottom: 5px;">核对无异常</span>

      </div>
      <div style="margin-bottom: 5px;color:orange"><span>提现后剩余余额: {{ checkResult.balance }}</span></div>
      <el-input v-model="auditForm.remark" placeholder="请输入失败原因或打款单号" />
      <el-button type="text" @click="showFollow = !showFollow">
        {{ showFollow ? '隐藏流水':'显示流水' }}
      </el-button>
      <div v-if="showFollow">
        <!-- 流水详情内容 -->
        <el-table
          :data="checkResult.flow"
          style="width: 100%"
        >
          <el-table-column
            prop="content"
            label="详情"
            width="180"
          />
          <el-table-column
            prop="name"
            label="金额"
          >
            <template slot-scope="{row}">
              {{ row.value/100 }}
            </template>
          </el-table-column>

        </el-table>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="aduitResult('fail')">审核失败</el-button>
        <el-button type="primary" @click="aduitResult('success')">审核成功</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

// const {
//   time: '',
//   begin_time: '',
//   all_time: '',
//   end_time: '',
//   grade_id: '',
//   subject_id: '',
//   error_num: ''
// }

import FileSaver from 'file-saver'
var moment = require('moment')

const frianceListQueryDefault = {
  p: 0,
  id: '',
  payment_method: '',
  status: '100',
  limit: 20,
  total: 0,
  mobile: '',
  time: '',
  begin_time: '',
  end_time: '',
  amount_down: 0,
  amount_up: 1000000
}

import Select from '@/components/Select'
import axios from 'axios'
import QS from 'qs'

export default {
  name: 'FrianceLists',
  components: { Select },
  data() {
    return {
      tableData: [],
      checkResult: '',
      paySelectsData: [
        { id: 'alipay', name: '支付宝' },
        { id: 'bank', name: '银行卡' }
      ],
      statusSelectsData: [
        { id: '0', name: '待总部审核' },
        { id: '100', name: '待财务审核' },
        { id: '101', name: '审核失败' },
        { id: '200', name: '已打款' }
      ],
      auditForm: {
        remark: '',
        id: '',
        audit_status: ''
      },
      showFollow: false,
      dialogVisible: false,
      gradeLists: [],
      subjectLists: [],
      frianceListQuery: Object.assign({}, frianceListQueryDefault)
    }
  },
  watch: {
    'frianceListQuery.time': {
      handler: function(newVal) {
        if (newVal && newVal.length > 1) {
          this.frianceListQuery.begin_time = moment(newVal[0]).format('YYYY-MM-DD')
          this.frianceListQuery.end_time = moment(newVal[1]).format('YYYY-MM-DD')
        } else {
          this.frianceListQuery.begin_time = ''
          this.frianceListQuery.end_time = ''
        }
      }
    }
  },
  mounted() {
    this.searchQuestion()
  },
  methods: {
    searchQuestion(type) {
      if (type === 'reset') {
        this.frianceListQuery.p = 1
      }
      this.$http.getFinanceWithdrawList(this.frianceListQuery).then(res => {
        this.frianceListQuery.total = parseInt(res.data.count || '0')
        this.tableData = res.data.list
      })
    },
    fnUpdateRemark(id, remark) {
      this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        inputPattern: /\S/,
        inputValue: remark || '',
        inputErrorMessage: '请填写备注信息'
      }).then(({ value }) => {
        console.log(value)
        this.$http.setFinanceWithdrawRemark({ id: id, remark: value }).then(res => {
          this.$message.success('备注添加成功')
          this.searchQuestion()
        })
      })
    },
    async startAuditing(row) {
      this.auditForm.id = row.id
      this.auditForm.remark = ''
      const res = await this.$http.balanceCheck({ master_id: row.master_id, id: row.id })
      this.checkResult = res.data
      this.dialogVisible = true
    },
    aduitResult(result) {
      if (result === 'success' && this.checkResult.check_pass === false) {
        this.$message.error('核对异常，无法审核通过')
        return
      }
      if (!this.auditForm.remark) {
        this.$message.error('请输入备注原因')
        return
      }
      this.auditForm.audit_status = result
      this.$http.financeWithdrawAudit(this.auditForm).then(res => {
        this.$message.success('审核成功')
        this.searchQuestion()
        this.dialogVisible = false
      })
    },
    fnDownloadData: function() {
      if (!this.frianceListQuery.begin_time) {
        this.$message.error('请选择时间范围')
        return
      }
      axios({
        method: 'post',
        url: `/Excelupload/downloadFinanceWithdrawList`,
        responseType: 'blob',
        data: QS.stringify(this.frianceListQuery) })
        .then(res => {
          FileSaver.saveAs(res.data, '家长提现列表.csv')
        })
    }
  }
}
</script>

<style lang="scss">
.custom-yue-dialog {
     .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
     }
     }
.sort-management-detail {
  .tuolele-main-search {
    padding-bottom: 20px;
  }
  .add-content-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    .add-content-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #333;
      opacity: 0.7;
    }
  }
  .add-content {
    width: 620px;
    background-color: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .add-header {
      width: 100%;
      padding: 25px 30px;
      border-bottom: 1px solid #f5f5f5;
      .title {
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        color: #4c84ff;
      }
      .close {
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
    .el-table tr th {
      background: #fff;
      color: #333;
    }
    .el-table td,
    .el-table th {
      border: 1px solid #ebebeb !important;
    }
  }
  .input1 {
    width: 211px;
    margin-right: 10px;
  }
  .add-content-main {
    display: flex;
    flex-direction: column;
    padding: 30px;
  }
  .add-content-table {
    margin: 20px auto;
  }
  .confirm-btn {
    margin: 50px 0 30px;
    .title {
      color: $color_black;
      margin-bottom: 10px;
      span {
        color: $color_blue;
      }
    }
  }
}
</style>
